export default "__VITE_ASSET__B$payXOa__"